<template>
  <b-form-group
    label="Notlar"
    label-for="notes"
  >
    <validation-provider
      #default="{ errors }"
      name="Notlar"
      rules="required"
    >
      <b-form-textarea
        id="notes"
        v-model="dataItem.notes"
        placeholder="Notlar"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup, BFormTextarea,
} from 'bootstrap-vue'
import { required } from '@validations'

export default {
  name: 'LicencesNotes',
  components: {
    BFormGroup,
    BFormTextarea,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['licenses/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
